module.exports = __webpack_public_path__ + "img/img4.db69351c.jpg";